<template>
    <div
        class="bg-white dark:bg-neutral-700 rounded-md border border-gray-300 dark:border-neutral-500 w-full h-full dark:text-white dark:[&_path]:!stroke-white dark:[&_line]:!stroke-white dark:[&_polygon]:!stroke-white dark:[&_.ql-picker]:!text-white">
        <!-- Use class h-full w-full for the editor -->
        <div ref="editor" class="h-full w-full">
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
        </div>
        <textarea :name="textareaName" class="hidden">{{ contentHtml }}</textarea>
    </div>
</template>
  
<script>
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

export default {
    props: {
        initialContent: {
            type: String,
            default: '', // Optional HTML to pre-fill editor
        },
        textareaName: {
            type: String,
            default: 'content', // Default field name if not provided
        },
    },
    data() {
        return {
            quill: null,
            contentHtml: this.initialContent,
        };
    },
    mounted() {
        this.quill = new Quill(this.$refs.editor, {
            theme: 'snow',
            placeholder: 'Write something...',
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline'],
                    [{ header: [1, 2, 3, false] }],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    ['link'],
                ]
            }
        });

        // Set initial content if provided
        if (this.contentHtml) {
            this.quill.root.innerHTML = this.contentHtml;
        }

        // Update contentHtml whenever editor changes
        this.quill.on('text-change', () => {
            this.contentHtml = this.quill.root.innerHTML;
        });
    },
};
</script>
  
<style>
/* Make sure the container and editor take full height */
.ql-container {
    border: none !important;
    box-shadow: none !important;
}

.ql-toolbar.ql-snow {
    border: none !important;
}
</style>
  